import { render, staticRenderFns } from "./TimeRespDeckBl.vue?vue&type=template&id=ba50948e&scoped=true&"
import script from "./TimeRespDeckBl.vue?vue&type=script&lang=js&"
export * from "./TimeRespDeckBl.vue?vue&type=script&lang=js&"
import style0 from "./TimeRespDeckBl.vue?vue&type=style&index=0&id=ba50948e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba50948e",
  null
  
)

/* custom blocks */
import block0 from "./TimeRespDeckBl.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports